'use strict';

angular.module('ticketAssignment')
    .controller('supportMetricsSettingsCtrl', [
        '$scope', 'supportMetricsSettingsViewModel',
        function ($scope, viewModel) {

            $scope.model = new viewModel();
        }
    ]);